import React from 'react';
import { DocumentMetaDisplayType, DocumentMetaType } from '../../../../types/articleType';
import { createNorwegianDateString } from '../../utils/createNorwegianDateString';
import * as S from './Styles';
import { DocumentTypeLabel } from '../../../../types/testType';

interface MetaDataProps {
  meta?: DocumentMetaType;
  metaDisplay?: DocumentMetaDisplayType;
  documentType?: DocumentTypeLabel;
}

export const MetaData = ({ meta, metaDisplay, documentType }: MetaDataProps) => {
  const shouldDisplayPublicationDate = meta && meta?.publishAt && !metaDisplay?.hidePublicationDate;
  const shouldDisplayUpdateDate = meta && meta?.updatedAt && !metaDisplay?.hideUpdateDate;
  const shouldDisplayEditor =
    meta && meta?.editor && !metaDisplay?.hideEditor && documentType !== DocumentTypeLabel.nafnoNewsArticle;

  const publicationDate = createNorwegianDateString(new Date(meta?.publishAt));
  const updateDate = createNorwegianDateString(new Date(meta?.updatedAt));

  return (
    <S.MetaDataWrapper>
      {shouldDisplayEditor && (
        <S.EditorWrapper>
          <S.Editor>{meta.editor.name}</S.Editor>
          <S.Position>{meta.editor.position}</S.Position>
        </S.EditorWrapper>
      )}
      {shouldDisplayUpdateDate && <S.UpdateDate>{`Sist oppdatert: ${updateDate}`}</S.UpdateDate>}
      {shouldDisplayPublicationDate && <S.PublishedDate>{`Publisert: ${publicationDate}`}</S.PublishedDate>}
    </S.MetaDataWrapper>
  );
};
